import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Badge } from "@/components/Badge";
import { Text } from "@/components/Text";
import { WorkOrderStatus } from "@/data/work-orders";
import { TColorVariant } from "@/style/colorVariants";

export interface IWorkOrderStatusBadgeProps {
  status: WorkOrderStatus;
}

export const WorkOrderStatusBadge: FC<IWorkOrderStatusBadgeProps> = memo(({ status }) => {
  const { t } = useTranslation("session");
  const color: TColorVariant = status === "CONFIRMATION_PENDING" ? "success" : "grey2";

  return (
    <Badge color="background-card" backgroundColor={color} borderColor={color} contentMargin={[false, "md"]}>
      <Text weight="bold">{t(`WORK_ORDERS.STATUS.${status}`)}</Text>
    </Badge>
  );
});
